export { default as component } from "../../../src/routes/skins/autograph-capsules/[slug]/+page.svelte";
export const has_server_load = true;